<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle"
                  data-toggle="collapse"
                  data-target="#navigation-example-2"
                  @click="toggleNavbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link class="navbar-brand" to="/"><img src="static/img/logo_branca_2025.png" alt="Avaliação de Desempenho" class="logo_ad"></router-link>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <router-link to="/suporte" tag="li">
              <a>Suporte</a>
            </router-link>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page" data-color=""
           data-image="static/img/background/background-2.jpg">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <form @submit.prevent="authenticate">
                  <div class="card card-login" data-background="color" data-color="blue">
                    <div class="card-header">
                      <h3 class="card-title">Login do Colaborador</h3>
                    </div>
                    <div class="card-content">
                      <div class="form-group">
                        <label>Matrícula</label>
                        <input type="text" v-model="form.username" placeholder="Preencha sua Matrícula" class="form-control input-no-border" inputmode="numeric" autocomplete="username">
                      </div>
                      <div class="form-group">
                        <label>CPF</label>
                        <input type="password" v-model="form.password" placeholder="Preencha seu CPF" class="form-control input-no-border" inputmode="numeric" autocomplete="password">
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <p class="authError text-danger" v-if="authError"> {{ authError }}</p>
                      <button type="submit" class="btn btn-fill btn-wd "> <loading-spin :check="loading" class="loading-spin-login"> </loading-spin> Entrar</button>
                      <div class="forgot">
                        <router-link to="/suporte">
                          Você tem alguma dúvida?
                        </router-link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              <img src="static/img/logo_brasal.png" alt="Brasal" class="logo_brasal">
            </div>
          </div>
        </footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/suporte" tag="li">
          <a>Suporte</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
import { login } from '../../../../../helpers/auth'

export default {
  name: 'login',
  data () {
    return {
      form: {
        username: '',
        password: ''
      },
      loading: false,
      error: null
    }
  },
  methods: {
    authenticate () {
      this.$store.dispatch('login')
      this.loading = true
      login(this.$data.form)
        .then((res) => {
          this.loading = false
          this.$store.commit('loginSuccess', res)
          this.$router.push({path: '/'})
          this.resetForm()
        })
        .catch((error) => {
          this.loading = false
          this.resetForm()
          this.$store.commit('loginFailed', {error})
        })
    },
    resetForm () {
      this.form.username = ''
      this.form.password = ''
    },
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    }
  },
  computed: {
    authError () {
      return this.$store.getters.authError
    }
  },
  beforeDestroy () {
    this.closeMenu()
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Auth/Login.vue